<div class="settings-modal">
  <div class="modal-content">
    <h2 class="modal-title">⚙️ Configuración de Alertas</h2>
    <p class="modal-subtitle">Activa o desactiva las alertas que necesites</p>

    <form class="settings-form">
      <div class="setting-item">
        <label class="switch">
          <input type="checkbox" [checked]="settings.vencido"
      (change)="toggleSetting('vencido', $event)" />
          <span class="slider round"></span>
        </label>
        <span class="setting-label">Pago Vencido</span>
      </div>

      <div class="setting-item">
        <label class="switch">
          <input type="checkbox"  [checked]="settings.atrasado"
      (change)="toggleSetting('atrasado', $event)" />
          <span class="slider round"></span>
        </label>
        <span class="setting-label">Pago Atrasado</span>
      </div>

      <div class="actions">
        <button type="button" class="btn cancel" (click)="cancel()">Cancelar</button>
        <button type="submit" class="btn save" (click)="savesettings()">Guardar</button>
      </div>
    </form>
  </div>
</div>
